<template>
  <el-container>
    <el-header>
      <Header title="鹿客竞练管理后台"></Header>
    </el-header>
    <div class="slide-img">
      <div class="classroom-info" v-if="classroom">
        <div class="classroom-avatar">
          <img :src="common.filepath(classroom.middlePicture)" />
        </div>
        <div class="classroom-desc">
          <h1>
            {{ classroom.title }}
          </h1>
          <div class="desc" id="desc">{{ classroom.about }}</div>
        </div>
        <div class="content-tab">
          <el-menu :default-active="$route.path" mode="horizontal" :router="true">
            <el-menu-item :index="`/classroom/index/` + $route.params.classroomId + `/path`" :class="$route.name === 'path' ? 'is-active' : ''">专题路径</el-menu-item>
            <el-menu-item :index="`/classroom/index/` + $route.params.classroomId + `/activity`">专题活动</el-menu-item>
          </el-menu>
          <div class="add-box">
            <el-button type="success" @click="joinClassroom()" v-if="!member">免费加入</el-button>
            <el-button type="success" @click="refundClassroom()" v-if="member&&!isTeacher">退出学习</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-main>
      <router-view :isLogin="isLogin" :courses="courses" :competitionData="competitionData" :member="member" v-if="courses"></router-view>
    </el-main>
  </el-container>
</template>
<script>
import { getToken } from "@/utils/auth";
import {
  getClassroomCourses,
  joinClassroom,
  refundClassroom
} from "@/api/classroom";
import Header from "@/layouts/app/Header";
import Common from "@/utils/common";
export default {
  components: {
    Header
  },

  created() {
    this.isLogin = getToken() ? true : false;


  },
  watch: {},
  data() {
    return {
      classroom: null,
      competitionData: null,
      courses: null,
      isTeacher: null,
      member: null,
      isLogin: false,
      competitionId: 1,
      activeName: "path"
    };
  },
  created() {
    this.handle();
  },
  methods: {
    handle() {
      getClassroomCourses(this.$route.params.classroomId).then(response => {
        this.classroom = response.data.classroom;
        this.competitionData = response.data.competitionData;
        this.courses = response.data.courses;
        this.member = response.data.member;
        this.isTeacher = response.data.isTeacher;
      });
    },
    joinClassroom() {
      joinClassroom(this.$route.params.classroomId).then(response => {

        if (response.data === true) {
          this.$message.success("加入成功");
          this.handle();
        } else {
          this.$message.error("加入失败");
        }
      });
    },
    refundClassroom() {
      refundClassroom(this.$route.params.classroomId).then(response => {

        if (response.data === true) {
          this.$message.success("退出成功");
          this.handle();
        } else {
          this.$message.error("退出失败");
        }
      });
    },
    addClassroom: function () {
      // if (!this.isLogin) {
      //   this.$router.push({
      //     name: "login",
      //     params: { type: "login" },
      //     query: { redirect: this.$route.path }
      //   });
      // }
    }
  }
};
</script>
<style scoped>
.slide-img {
  width: 100%;
  position: relative;
  background-image: url(../../assets/imgs/c-back.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.classroom-info {
  width: 1000px;
  height: 300px;
  margin: auto;
  padding: 30px 0px;
  box-sizing: border-box;
  color: #ffffff;
  position: relative;
}
.classroom-avatar {
  width: 120px;
  padding-top: 60px;
  float: left;
  margin: 0 30px;
}
.classroom-avatar img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
.classroom-info .classroom-desc {
  padding-top: 50px;
  width: calc(100% - 180px);
  float: left;
}
.classroom-info .classroom-desc h1 {
  font-size: 2rem;
  margin-bottom: 10px;
}
.classroom-info .classroom-desc h1 i {
  font-size: 20px;
  position: relative;
  top: -10px;
  right: -10px;
  cursor: pointer;
}
.classroom-info .classroom-desc .desc {
  height: calc(100% - 95px);
  overflow: auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}
.classroom-info .classroom-desc p {
  line-height: 30px;
}

.classroom-info /deep/ .el-breadcrumb__item /deep/ span {
  color: #ffffff !important;
}
.classroom-info .classroom-setting {
  position: absolute;
  top: 30px;
  right: 0;
  font-size: 24px;
  cursor: pointer;
}
.content-tab {
  width: 1000px;
  /* margin: 15px auto; */
  position: absolute;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #ffffff;
  bottom: 0;
}
.content-tab >>> .el-menu {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 0 30px;
}
.content-tab >>> .el-menu-item {
  color: #000000;
}
.content-tab .add-box {
  position: absolute;
  top: 10px;
  right: 40px;
}

#desc::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
#desc::-webkit-scrollbar-track {
  background: #464545;
  border-radius: 2px;
}
#desc::-webkit-scrollbar-thumb {
  background: #413d3d;
  border-radius: 10px;
}
#desc::-webkit-scrollbar-thumb:hover {
  background: #312f2f;
}
</style>
